import { cn } from '@/lib/utils';
import type { TriggerEventConfig } from '../config/events';
import type { TriggerEventType } from '../types';

interface EventCardProps {
  eventKey: TriggerEventType;
  config: TriggerEventConfig;
  selected: boolean;
  onSelect: () => void;
}

/**
 * EventCard
 * 
 * Карточка события триггера
 * 
 * @returns {React.ReactElement} React компонент
 */
export function EventCard({ config, selected, onSelect }: EventCardProps) {
  const Icon = config.icon;

  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        'w-full p-4 border rounded-lg text-left transition-all hover:border-primary/50',
        selected && 'border-primary bg-primary/5 ring-2 ring-primary ring-offset-2'
      )}
    >
      <div className="flex items-start gap-3">
        <div
          className={cn(
            'p-2 rounded-lg',
            selected ? 'bg-primary/20 text-primary' : 'bg-muted text-muted-foreground'
          )}
        >
          <Icon className="h-5 w-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-medium">{config.label}</div>
          <div className="text-sm text-muted-foreground mt-0.5">{config.description}</div>
          {config.examples.length > 0 && (
            <div className="mt-2 text-xs text-muted-foreground/80">
              <span className="font-medium">Примеры:</span> {config.examples.join(', ')}
            </div>
          )}
        </div>
      </div>
    </button>
  );
}
